import React from 'react';
import styled from 'styled-components';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import Celula from '../../Common/Celula';
import { MesExtenso } from '../../Helpers/date';
import MoreInfo from './index';

const TabelaLinha = styled(TL)`
  grid-template-columns: 280px 45px 45px 60px;
`

export default function MIFerias (props) {
  const { dados={} } = props;
  const { empresa, mes, ano } = dados;
  return (
    <MoreInfo
      titulo={empresa}        
      subtitulo={`Férias (${MesExtenso(dados.mes-1)}/${dados.ano})`}
      f={{
        url: `${proto}://${url}/main/metricas/pessoal/ferias`,
        opt: {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ empresa, mes, ano })
        },
      }}
      modalData={dados}
    >
    {data => data && (
      <Tabela>
        <TabelaLinha header>
          <Celula>Nome</Celula>
          <Celula>Início</Celula>
          <Celula>Término</Celula>
          <Celula>Total de dias</Celula>
        </TabelaLinha>
        {data.map(e => {
          return (
            <TabelaLinha>
              <Celula>{e.nome}</Celula>
              <Celula>{e.inicio}</Celula>
              <Celula>{e.fim}</Celula>
              <Celula>{e.dias}</Celula>
            </TabelaLinha>
          )
        })}
      </Tabela>

    )}
    </MoreInfo>
  )
}
